var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center u-height-100 u-width-100"},[_c('HotelDetailsEmptyStateIcon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }